import { useQuery } from "@tanstack/react-query";
import { getAllUserWalletSummaries } from "../../../api/admin/commission";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
const WalletAdminView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["admin-wallet-summaries"],
    queryFn: getAllUserWalletSummaries,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isError) {
    return <p className="text-red-500 text-center mt-6">{error.message}</p>;
  }

  const summaries = data?.data?.summaries || [];

  return (
    <>
      {/* Centered Main Wallet Balance */}
      <div className="flex justify-center items-center flex-col mt-4">
        <p className="text-lg font-semibold text-gray-700">
          {t("wallet").mainBalance}
        </p>
        <p className="text-3xl font-bold text-blue-600 mt-1">
          ₾{data?.data?.mainWalletBalance?.toFixed(2)}
        </p>
      </div>

      {/* Wallet Summary Cards */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {summaries.map((summary) => (
          <div
            key={summary.userId}
            className="p-5 border rounded-lg shadow-sm bg-white flex flex-col justify-between"
          >
            <div className="flex items-center gap-4">
              <img
                src={`${summary.user?.profilePicture}`}
                alt={summary.user?.name}
                className="w-14 h-14 rounded-full object-cover"
              />
              <div>
                <p className="font-semibold text-lg">{summary.user?.name}</p>
                <p className="text-sm text-gray-500">{summary.user?.email}</p>
                <p className="text-xs text-gray-400 capitalize">
                  {summary.user?.role}
                </p>
              </div>
            </div>

            <div className="mt-4">
              <p className="text-sm text-gray-500">{t("wallet").netBalance}</p>
              <p
                className={`text-xl font-bold ${
                  summary.netBalance >= 0 ? "text-green-600" : "text-red-600"
                }`}
              >
                ₾{summary.netBalance.toFixed(2)}
              </p>
            </div>

            <div className="mt-4">
              <button
                // onClick={() => navigate(`/admin/pay-user/${summary.userId}`)}
                className="w-full flex items-center justify-center gap-2 bg-[#4CAF50] hover:bg-[#209b25] text-white text-sm font-semibold px-4 py-2 rounded-md"
              >
                {t("wallet").payButton}
                <HiOutlineArrowNarrowRight />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default WalletAdminView;
